import React from 'react';
import { connect } from 'react-redux'
import { NAME as DASHBOARD_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as dashboardContainerActions } from '../actions'
import 'assets/css/styleDashboard.css'
import { strings } from "../../../constants/strings";
import DashboardModal from '../components/DashboardModal'
import { OtherBadges } from '../../../components/Badges'

let wpmTestTb = '/react/images/dashboard/wpmtest_tp.svg'
//let wpmTestTb = '/images/dashboard/wpmtest_tp.svg'
let PowerReaderTb = '/react/images/dashboard/powerreader_tp.svg'
//let PowerReaderTb = '/images/dashboard/powerreader_tp.svg'

function mapStateToProps(state) {
  return {
    ...state[DASHBOARD_NAME]
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...dashboardContainerActions
}, dispatch)

class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    props.initExercises()
    // Web_Dashboard_Amazonbtn To DO
  }

  componentDidMount() {
  }

  render() {
    //console.log(this.props.exercises)
    return (
      <>
      <div className='row'>
        <div className='left-exercise'>
          <div className="row" style={{ height: "100%", margin: 0 }}>
            <div className="le-l mr-auto">
              <div>{strings.ExerciseListView_lbl_Trainingsplan}</div>
              <div class="flex">
                <a href="#" className="locked-curric" onClick={this.props.showCurriculum}><img src={wpmTestTb} width={100} /></a>
              </div>
            </div>
            <div className="le-r">
              <div>{strings.List_ExerciseProvider_Title_Powerreader}</div>
              <div class="flex">
                <a href="#" className="locked-power" onClick={this.props.showPowerReader}><img src={PowerReaderTb} width={100} /></a>
              </div>
            </div>
          </div>
        </div>

        <div className='dashboard-exercise-panel' style={{          
          marginBottom: 15+'px'
        }}>
            <div className="dashboard-field-small">
              <div style={{ textAlign: 'left' }}>{strings.Web_ExerciseList_Title}</div>
              <div className="row" style={{ margin: 0 }}>
                {this.props.exercises.map((item) => {
                  return (
                    <div className="col-3" key = {item.id}>
                      <a 
                      id={item.id} 
                      href={item.link} 
                      className={item.accessibility === 'unavailable' ? 'locked-ex' : item.accessibility === 'premium' ? 'premium-ex' : null}
                      onClick={item.accessibility === 'unavailable' ? this.props.showLockedModal : item.accessibility === 'premium' ? this.props.showPremiumLocked : null}
                      >
                        <img style={{
                          cursor: 'pointer'
                        }}
                          src={item.image.default} width={80} />
                      </a>
                      <h6>{item.name}</h6>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>

        <div className="row dashboard-field-results">
          <div
          dangerouslySetInnerHTML={{__html: strings.Dashboard_banner}}
          ></div>
          <div>
            <OtherBadges/>
          </div>
        </div>
        <DashboardModal
        modalIsVisible = {this.props.modalIsVisible}
        showModal = {this.props.showModal}
        hideModal = {this.props.hideModal}
        titleTxt = {this.props.modalTxts.titleTxt}
        contentTxt = {this.props.modalTxts.contentTxt}
        botTitleTxt = {this.props.modalTxts.botTitleTxt}
        isPremiumModal = {this.props.modalTxts.isPremiumModal}
        amazonBtnClass = {this.props.modalTxts.amazonBtnClass}
        googleBtnClass = {this.props.modalTxts.googleBtnClass}
        appleBtnClass = {this.props.modalTxts.appleBtnClass}
        buttonTxt = {this.props.modalTxts.buttonTxt}
        />
      </>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
